import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

function createTableData(content)
{
	let columns = content.columns.map(obj => obj["name"]);
	let rows = content.rows;

	return rows.map((row) =>
	{
		return columns.reduce((rowDataAcc, column, index) =>
		{
			rowDataAcc[column] = row[index];
			return rowDataAcc;
		}, {});
	});
}

function setColumnDefs(columns){
	return columns.map(col => ({
		field: col,
		minWidth: 70,
		maxWidth: 500,
		sortable: true,
		filter: true
	}));
}

class MySqlResponse extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			rowData: createTableData(this.props.value),
			columnDefs: setColumnDefs(this.props.value.columns.map(obj => obj["name"]))
		};
	}
	onGridReady = (params) => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		params.api.sizeColumnsToFit();
	};

	render() {
		return (
			<div style={{ height: '100%' }}>
				<div
					id="myGrid"
					style={{
						height: 'calc(100% - 25px)'
					}}
					className="ag-theme-material"
				>
					<div style={{height: '400px', width: '100%'}}>
						<AgGridReact
							rowData={this.state.rowData}
							columnDefs={this.state.columnDefs}
							defaultColDef={
								{ resizable: true }
							}
							onGridReady={this.onGridReady}
							rowSelection="multiple"
							multiSortKey='shift'
							animateRows='true'
							enableCellTextSelection='true'
							ensureDomOrder='true'
							domLayout='autoHeight'
							pagination= 'true'
							paginationPageSize={5}
							rowHeight={75}
						/>
					</div>

				</div>
			</div>
		);
	}
}

export default MySqlResponse;